import React from 'react';
import { Link } from 'react-router-dom';

const ExploreCategoriesPage = () => {
  const categories = [
    { key: 'servicios-legales', label: 'Servicios legales' },
    { key: 'salud', label: 'Salud' },
    { key: 'servicios-paralegales', label: 'Servicios paralegales' },
    { key: 'traducciones-certificadas', label: 'Traducciones Certificadas' },
    { key: 'aseo', label: 'Aseo' },
    { key: 'transporte', label: 'Transporte' },
    { key: 'belleza', label: 'Belleza' },
    { key: 'catering-y-eventos', label: 'Catering y eventos' },
    { key: 'tiendas-y-productos', label: 'Tiendas y productos' },
    { key: 'otros-servicios', label: 'Otros servicios' }
  ];

  return (
    <div className="directory-page">
      <section className="map-section">
        <div className="container">
          <div className="section-header">
            <h1 className="section-title">Categorías de Servicios</h1>
            <p className="section-description">
              Selecciona una categoría para explorar profesionales y empresas verificadas.
            </p>
          </div>

          <div className="features-grid">
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={`/explora?categoria=${encodeURIComponent(cat.key)}`}
                className="btn btn-primary"
                style={{ justifyContent: 'center', textAlign: 'center' }}
              >
                {cat.label}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ExploreCategoriesPage;
